import { useState } from "react";
import { Label, Modal } from "flowbite-react";
import { useFormik } from "formik";
import ValidToast from "../toasts/ValidToast";
import UnvalidToast from "../toasts/UnvalidToast";
import { shareExp } from "../../services/callAPI/trocsRequests";
import { object, string } from "yup";
import { cleanInputValue } from "../../services/hooks/sanitizeValue/cleanInputValue";
import { isSanitizeDescripValue } from "../../services/hooks/sanitizeValue/isSanitizeDescipValue";

interface IShareExpModalProps {
  id: number;
  trocTId: number,
  setTrigUseEffect: React.Dispatch<React.SetStateAction<boolean>>
}

function ShareExpModal(props: IShareExpModalProps) {
  //destructuring
  const { id, trocTId, setTrigUseEffect } = props;

  const [openModal, setOpenModal] = useState(false);

  const [_comment, _setComment] = useState<string>("");

  const [isShowValidToast, setIsShowValidToast] = useState<boolean>(false);

  const [isShowUnvalidToast, setIsShowUnvalidToast] = useState<boolean>(false);

  //set validation schema with Yup
  const shareExpSchema = object({
    content: string()
      .trim()
      .min(20, "Le commentaire doit comporter au moins 20 caractères")
      .max(160, "Le commentaire ne peut pas dépasser 160 caractères")
      .test("is-pseudo-valid", "le commentaire contient des caractères interdits", (value) => isSanitizeDescripValue(value))
      .matches(/^[a-zA-ZÀ-ÿ_.,'!?; ]+$/, "Peut contenir des lettres, et certains caractères spéciaux(_.,'!?;)")
      .required(`Vous avez oublié votre commentaire`),
  })

  // set formik
  const { handleSubmit, errors, touched, values, resetForm, setFieldValue } = useFormik({
    initialValues: {
      content: "",
    },
    validationSchema: shareExpSchema,
    onSubmit: async values => {
      try {
        //call Api
        const response = await shareExp(values, id, trocTId);

        if (response.status === 204) { //success register
          //reset form
          resetForm();

          //close modal
          setOpenModal(false);

          //show ValidToast
          setIsShowValidToast(true);

          setTimeout(() => {
            setTrigUseEffect(prev => !prev);
          }, 2000);
        }
        else {//failure register
          throw new Error(`Erreur lors de l'appel API code statut: ${response.status}`);
        }
      }
      catch (error) {
        //show UnvalidToast
        setIsShowUnvalidToast(true);

        // missing toast next 3s
        setTimeout(() => {
          setIsShowUnvalidToast(false);
        }, 3000);

      }
    }
  })

  return (
    <>
      {isShowValidToast && <ValidToast onClose={() => setIsShowValidToast(false)} />}
      {isShowUnvalidToast && <UnvalidToast onClose={() => setIsShowUnvalidToast(false)} />}

      <button className="w-1/2 max-w-52 bg-greenCustom text-white rounded-md py-1 ml-auto" onClick={() => setOpenModal(true)}>Laisser un commentaire</button>

      <Modal className="p-6 bg-transparent backdrop-blur-sm" show={openModal} size="md" popup onClose={() => setOpenModal(false)}>
        <Modal.Body>
          <form action="" onSubmit={handleSubmit} >

            <div className="space-y-6">

              <h3 className="text-xl font-medium text-center text-gray-900 dark:text-white">Je partage cette expérience :</h3>

              <div>

                <div className="mb-2 block">
                  <Label htmlFor="content" value="" />
                </div>

                {/* Mon commentaire */}
                <textarea
                  id="content"
                  name="content"
                  value={values.content}
                  onChange={(e) => {
                    const cleaned = cleanInputValue(e.target.value);
                    setFieldValue("content", cleaned);
                  }}
                  placeholder="Laisser un commentaire ..."
                  className="border rounded w-full"
                  rows={4}
                />

                <p className="text-end text-gray-400">160 caractères max</p>

                {touched.content && errors.content && <span className="text-red-500 text-sm">{errors.content}</span>}

              </div>

              <div className="flex justify-around w-full">
                <button type="submit" className="bg-greenCustom py-1 px-3 rounded-xl w-1/3 text-white flex justify-center">Envoyer</button>
                <button className="bg-lightRedCustom py-1 px-3 rounded-xl w-1/3 text-white flex justify-center" onClick={() => { resetForm(), setOpenModal(false) }}>Retour</button>
              </div>

            </div>

          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ShareExpModal;
